import PropTypes from 'prop-types';
import ForecastValueTransactions from './ForecastValueTransactions';

export default function ForecastValueIgnored(props) {
    const { cell, forecastId } = props;

    return (
        <div className="pt-2 min-h-full relative flex flex-col">
            <div className="mb-6 opacity-50 text-xs empty:hidden">{cell?.period_label}</div>

            <ForecastValueTransactions cell={cell} forecastId={forecastId} ignored />
        </div>
    );
}

ForecastValueIgnored.propTypes = {
    forecastId: PropTypes.string.isRequired,
    cell: PropTypes.object,
};

ForecastValueIgnored.drawerStackProps = {
    size: 'lg',
};
